import { useNavigate } from 'react-router-dom';
import InquiryConfirmed from '../pages/InquiryConfirmed';

const InquiryConfirmedWrapper = () => {
  const navigate = useNavigate();
  return <InquiryConfirmed navigate={navigate} />;
};

export default InquiryConfirmedWrapper;
